export const truncateString = value => `${value.slice(0, 3)}.`

export const cuilFormatter = value => value ? `${value.slice(0, 2)}-${value.slice(2, 10)}-${value.slice(10)}` : ''

export const numberFormatter = (value: string) => value.replace(/[^0-9]/gi, '')

export const textFormatter = value => value.replace(/[^a-zñ´áéíóú ]+/gi, '')

export const alphanumericFormatter = value => value.replace(/[^a-z0-9 ]/gi, '')

export const normalizeString = value => value.replaceAll(' ', '').toLowerCase()

export const removeHyphens = value => value.replaceAll('-', '')

export const capitalize = (word: string) => word
  .toLowerCase()
  .charAt(0)
  .toUpperCase() + word.slice(1)

export const capitalizeByWord = (sentence: string): string => sentence
  .toLocaleLowerCase()
  .split(' ')
  .map((word) => capitalize(word))
  .join(' ')

export const pluralize = (quantity: number, word: string, suffix: string = 's') => `${word}${quantity > 1 ? suffix : ''}`

export const stringToBoolean = (value) => {
  if (!value) {
    return false
  }
  switch (value.toLowerCase().trim()) {
    case 'true':
      return true
    case 'false':
      return false
    default: return false
  }
}

export const insertCharIntoString = (str, index, value) => str.substr(0, index) + value + str.substr(index)

export const formatSeconds = (seconds) => {
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60

  const formattedMinutes = String(minutes).padStart(2, '0')
  const formattedSeconds = String(remainingSeconds).padStart(2, '0')

  return `${formattedMinutes}:${formattedSeconds}`
}

